<template>
  <div class="px-5">
    <div class="text-black text-2xl mt-10">
      <div class="flex items-center justify-between">
        <div class="my-3 font-bold">{{ supplierInfo.org_info&&supplierInfo.org_info.name }}</div>
        <button
          @click="handleOpenLink"
          type="button"
          class="flex items-center justify-center border-0 focus:outline-none mx-3 bg-blue-700 text-white rounded-md h-10 px-3 py-2 fs-20"
        >
          {{ $t('lbl_go_to_service') }}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="ml-3"
          >
            <path
              d="M21 16H7C6.73478 16 6.48043 15.8946 6.29289 15.7071C6.10536 15.5196 6 15.2652 6 15C6 14.7348 6.10536 14.4804 6.29289 14.2929C6.48043 14.1054 6.73478 14 7 14H17.44C18.1087 14 18.7582 13.7767 19.2854 13.3654C19.8126 12.9542 20.1873 12.3786 20.35 11.73L22 5.24C22.0375 5.09241 22.0407 4.93821 22.0095 4.78917C21.9783 4.64013 21.9135 4.50018 21.82 4.38C21.7227 4.25673 21.5978 4.1581 21.4554 4.09208C21.3129 4.02606 21.1569 3.99452 21 4H6.76C6.55369 3.41645 6.17193 2.911 5.66707 2.55294C5.1622 2.19488 4.55894 2.00174 3.94 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4H3.94C4.16843 3.99334 4.39226 4.06513 4.57421 4.20341C4.75615 4.34169 4.88525 4.53812 4.94 4.76L5 5.24L6.73 12C5.93435 12.0358 5.18551 12.3862 4.64822 12.9741C4.11093 13.5621 3.8292 14.3394 3.865 15.135C3.9008 15.9306 4.25121 16.6795 4.83914 17.2168C5.42707 17.7541 6.20435 18.0358 7 18H7.18C7.01554 18.4531 6.96269 18.9392 7.02593 19.4171C7.08917 19.895 7.26665 20.3506 7.54332 20.7454C7.81999 21.1401 8.18772 21.4624 8.61535 21.6849C9.04299 21.9074 9.51795 22.0235 10 22.0235C10.4821 22.0235 10.957 21.9074 11.3846 21.6849C11.8123 21.4624 12.18 21.1401 12.4567 20.7454C12.7334 20.3506 12.9108 19.895 12.9741 19.4171C13.0373 18.9392 12.9845 18.4531 12.82 18H15.18C15.0155 18.4531 14.9627 18.9392 15.0259 19.4171C15.0892 19.895 15.2666 20.3506 15.5433 20.7454C15.82 21.1401 16.1877 21.4624 16.6154 21.6849C17.043 21.9074 17.5179 22.0235 18 22.0235C18.4821 22.0235 18.957 21.9074 19.3846 21.6849C19.8123 21.4624 20.18 21.1401 20.4567 20.7454C20.7334 20.3506 20.9108 19.895 20.9741 19.4171C21.0373 18.9392 20.9845 18.4531 20.82 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM19.72 6L18.41 11.24C18.3552 11.4619 18.2262 11.6583 18.0442 11.7966C17.8623 11.9349 17.6384 12.0067 17.41 12H8.78L7.28 6H19.72ZM10 20C9.80222 20 9.60888 19.9414 9.44443 19.8315C9.27998 19.7216 9.15181 19.5654 9.07612 19.3827C9.00043 19.2 8.98063 18.9989 9.01921 18.8049C9.0578 18.6109 9.15304 18.4327 9.29289 18.2929C9.43275 18.153 9.61093 18.0578 9.80491 18.0192C9.99889 17.9806 10.2 18.0004 10.3827 18.0761C10.5654 18.1518 10.7216 18.28 10.8315 18.4444C10.9414 18.6089 11 18.8022 11 19C11 19.2652 10.8946 19.5196 10.7071 19.7071C10.5196 19.8946 10.2652 20 10 20ZM18 20C17.8022 20 17.6089 19.9414 17.4444 19.8315C17.28 19.7216 17.1518 19.5654 17.0761 19.3827C17.0004 19.2 16.9806 18.9989 17.0192 18.8049C17.0578 18.6109 17.153 18.4327 17.2929 18.2929C17.4327 18.153 17.6109 18.0578 17.8049 18.0192C17.9989 17.9806 18.2 18.0004 18.3827 18.0761C18.5654 18.1518 18.7216 18.28 18.8315 18.4444C18.9414 18.6089 19 18.8022 19 19C19 19.2652 18.8946 19.5196 18.7071 19.7071C18.5196 19.8946 18.2652 20 18 20Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <div class="bg-white rounded-3xl p-3">
        <!-- Organization Info -->
        <div class="border p-3 rounded-xl mt-1 mb-4">
          <div class="row fs-17 text-black">
            <div class="col-lg-10 mb-2">
              <span>{{`${$t('lbl_supplier_name')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.org_info&&supplierInfo.org_info.name }}</span>
            </div>
            <div class="col-lg-2 mb-2">
              <svg
                @click="$router.push({name:'OrganizationEcomUpdate'})"
                class="float-right cursor-pointer"
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
              >
                <path
                  d="M16.6201 9.00044C16.4212 9.00044 16.2304 9.07946 16.0898 9.22011C15.9491 9.36076 15.8701 9.55153 15.8701 9.75044V14.2504C15.8701 14.4494 15.7911 14.6401 15.6504 14.7808C15.5098 14.9214 15.319 15.0004 15.1201 15.0004H4.62012C4.4212 15.0004 4.23044 14.9214 4.08979 14.7808C3.94913 14.6401 3.87012 14.4494 3.87012 14.2504V3.75044C3.87012 3.55153 3.94913 3.36076 4.08979 3.22011C4.23044 3.07946 4.4212 3.00044 4.62012 3.00044H9.12012C9.31903 3.00044 9.50979 2.92142 9.65045 2.78077C9.7911 2.64012 9.87012 2.44935 9.87012 2.25044C9.87012 2.05153 9.7911 1.86076 9.65045 1.72011C9.50979 1.57946 9.31903 1.50044 9.12012 1.50044H4.62012C4.02338 1.50044 3.45108 1.7375 3.02913 2.15945C2.60717 2.58141 2.37012 3.15371 2.37012 3.75044V14.2504C2.37012 14.8472 2.60717 15.4195 3.02913 15.8414C3.45108 16.2634 4.02338 16.5004 4.62012 16.5004H15.1201C15.7169 16.5004 16.2892 16.2634 16.7111 15.8414C17.1331 15.4195 17.3701 14.8472 17.3701 14.2504V9.75044C17.3701 9.55153 17.2911 9.36076 17.1504 9.22011C17.0098 9.07946 16.819 9.00044 16.6201 9.00044ZM5.37012 9.57044V12.7504C5.37012 12.9494 5.44914 13.1401 5.58979 13.2808C5.73044 13.4214 5.9212 13.5004 6.12012 13.5004H9.30012C9.39882 13.501 9.49667 13.4821 9.58805 13.4448C9.67942 13.4074 9.76254 13.3525 9.83262 13.2829L15.0226 8.08544L17.1526 6.00044C17.2229 5.93072 17.2787 5.84777 17.3168 5.75638C17.3549 5.66498 17.3745 5.56695 17.3745 5.46794C17.3745 5.36893 17.3549 5.2709 17.3168 5.17951C17.2787 5.08812 17.2229 5.00516 17.1526 4.93544L13.9726 1.71794C13.9029 1.64765 13.8199 1.59185 13.7285 1.55377C13.6372 1.5157 13.5391 1.49609 13.4401 1.49609C13.3411 1.49609 13.2431 1.5157 13.1517 1.55377C13.0603 1.59185 12.9773 1.64765 12.9076 1.71794L10.7926 3.84044L5.58762 9.03794C5.51811 9.10802 5.46311 9.19113 5.42579 9.28251C5.38847 9.37389 5.36955 9.47174 5.37012 9.57044ZM13.4401 3.30794L15.5626 5.43044L14.4976 6.49544L12.3751 4.37294L13.4401 3.30794ZM6.87012 9.87794L11.3176 5.43044L13.4401 7.55294L8.99262 12.0004H6.87012V9.87794Z"
                  fill="#03267A"
                />
              </svg>
            </div>
            <div class="col-lg-12 mb-2">
              <span>{{`${$t('lbl_company_name')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.name }}</span>
            </div>
            <div class="col-lg-4 mb-2">
              <span>{{`${$t('lbl_website')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.contact || '' }}</span>
            </div>
            <div class="col-lg-4 mb-2">
              <span>{{`${$t('lbl_hotline')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.phone_number }}</span>
            </div>
            <div class="col-lg-12 mb-2">
              <span>{{`${$t('lbl_description_detail')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.description }}</span>
            </div>
            <div class="col-lg-4">
              <span>{{`${$t('lbl_bank')}: `}}</span>
              <span class="font-bold">{{ bankName || '' }}</span>
            </div>
            <div class="col-lg-4">
              <span>{{`${$t('lbl_bank_number')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.payment_account_no|| '' }}</span>
            </div>
            <div class="col-lg-4">
              <span>{{`${$t('lbl_banker_name')}: `}}</span>
              <span class="font-bold">{{ supplierInfo.payment_account_name|| '' }}</span>
            </div>
          </div>
        </div>
        <!-- Organization Admin -->
        <template v-if="!isProcessor">
          <div class="mb-4">
            <div class="fs-22 font-bold text-black mb-3">{{ $t('lbl_role') }}</div>
            <div class="flex gap-3 flex-wrap">
              <div v-for="item in adminMembers" :key="item.id">
                <img v-if="item && item.avatar" class="avatar_admin" :src="getAvatar(item)" />
                <div v-else class="no_avatar_admin">{{ getText(item) }}</div>
              </div>
              <div class="button_add">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M15.8333 9.16659H10.8333V4.16659C10.8333 3.94557 10.7455 3.73361 10.5892 3.57733C10.433 3.42105 10.221 3.33325 9.99998 3.33325C9.77897 3.33325 9.567 3.42105 9.41072 3.57733C9.25444 3.73361 9.16665 3.94557 9.16665 4.16659V9.16659H4.16665C3.94563 9.16659 3.73367 9.25438 3.57739 9.41066C3.42111 9.56694 3.33331 9.7789 3.33331 9.99992C3.33331 10.2209 3.42111 10.4329 3.57739 10.5892C3.73367 10.7455 3.94563 10.8333 4.16665 10.8333H9.16665V15.8333C9.16665 16.0543 9.25444 16.2662 9.41072 16.4225C9.567 16.5788 9.77897 16.6666 9.99998 16.6666C10.221 16.6666 10.433 16.5788 10.5892 16.4225C10.7455 16.2662 10.8333 16.0543 10.8333 15.8333V10.8333H15.8333C16.0543 10.8333 16.2663 10.7455 16.4226 10.5892C16.5788 10.4329 16.6666 10.2209 16.6666 9.99992C16.6666 9.7789 16.5788 9.56694 16.4226 9.41066C16.2663 9.25438 16.0543 9.16659 15.8333 9.16659Z"
                    fill="#20419b"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <div class="fs-22 font-bold text-black mt-4 mb-3">{{ $t('lbl_lab') }}</div>
            <div
              class="flex items-start sm:items-center justify-start sm:justify-between flex-col sm:flex-row gap-2"
            >
              <div class="flex items-center border bg-white rounded-md border-grey-300 p-2 w-60">
                <IconSearch class="cursor-pointer" />
                <input
                  v-model="valueSearch"
                  @input="handleSearch"
                  class="border-0 txt-grey-500 ml-2 focus:outline-none w-full"
                  :placeholder="$t('lbl_enter_name')"
                />
              </div>
              <div class="flex items-center">
                <ButtonHoDo
                  @click="onShowModalAddProcessor(true)"
                  :title="$t('lbl_add_new')"
                  class-name="bg-blue-700 text-white rounded-lg h-9 px-3 py-2"
                />
              </div>
            </div>
            <div class="table-responsive">
              <div class>
                <div class="fs-20 fw-600 row p-6 border-bottom border-gray-700 mb-6 pb-3">
                  <div class="txt-grey-1000 col-4">{{ $t('lbl_lab') }}</div>
                  <div class="txt-grey-1000 col-4">{{ $t('lbl_address') }}</div>
                  <div class="txt-grey-1000 col-3">{{ $t('lbl_phone') }}</div>
                  <div class="col-1"></div>
                </div>
                <div>
                  <div
                    v-for="(item, index) in processor"
                    :key="index"
                    class="cursor-pointer mb-2 radius-10 bg-blue-gray row p-6 fs-16 fw-400 txt-grey-900"
                  >
                    <div class="fw-700 col-4">
                      <div>{{ item.org_info&&item.org_info.name }}</div>
                    </div>
                    <div class="col-4">
                      <div>{{ item.org_info&&item.org_info.address }}</div>
                    </div>
                    <div class="col-3">
                      <div>{{ item.org_info&&item.org_info.contact_point }}</div>
                    </div>
                    <div class="col-1">
                      <svg
                        @click.stop="handleEditProcessor(item)"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 11.9999C20.7348 11.9999 20.4804 12.1053 20.2929 12.2928C20.1054 12.4804 20 12.7347 20 12.9999V18.9999C20 19.2652 19.8946 19.5195 19.7071 19.707C19.5196 19.8946 19.2652 19.9999 19 19.9999H5C4.73478 19.9999 4.48043 19.8946 4.29289 19.707C4.10536 19.5195 4 19.2652 4 18.9999V4.99994C4 4.73472 4.10536 4.48037 4.29289 4.29283C4.48043 4.1053 4.73478 3.99994 5 3.99994H11C11.2652 3.99994 11.5196 3.89458 11.7071 3.70705C11.8946 3.51951 12 3.26516 12 2.99994C12 2.73472 11.8946 2.48037 11.7071 2.29283C11.5196 2.1053 11.2652 1.99994 11 1.99994H5C4.20435 1.99994 3.44129 2.31601 2.87868 2.87862C2.31607 3.44123 2 4.20429 2 4.99994V18.9999C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 21.9999 5 21.9999H19C19.7956 21.9999 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 18.9999V12.9999C22 12.7347 21.8946 12.4804 21.7071 12.2928C21.5196 12.1053 21.2652 11.9999 21 11.9999ZM6 12.7599V16.9999C6 17.2652 6.10536 17.5195 6.29289 17.707C6.48043 17.8946 6.73478 17.9999 7 17.9999H11.24C11.3716 18.0007 11.5021 17.9755 11.6239 17.9257C11.7457 17.8759 11.8566 17.8026 11.95 17.7099L18.87 10.7799L21.71 7.99994C21.8037 7.90698 21.8781 7.79637 21.9289 7.67452C21.9797 7.55266 22.0058 7.42195 22.0058 7.28994C22.0058 7.15793 21.9797 7.02722 21.9289 6.90536C21.8781 6.7835 21.8037 6.6729 21.71 6.57994L17.47 2.28994C17.377 2.19621 17.2664 2.12182 17.1446 2.07105C17.0227 2.02028 16.892 1.99414 16.76 1.99414C16.628 1.99414 16.4973 2.02028 16.3754 2.07105C16.2536 2.12182 16.143 2.19621 16.05 2.28994L13.23 5.11994L6.29 12.0499C6.19732 12.1434 6.12399 12.2542 6.07423 12.376C6.02446 12.4979 5.99924 12.6283 6 12.7599ZM16.76 4.40994L19.59 7.23994L18.17 8.65994L15.34 5.82994L16.76 4.40994ZM8 13.1699L13.93 7.23994L16.76 10.0699L10.83 15.9999H8V13.1699Z"
                          fill="#20409B"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ModalAddProcessor
      :isUpdate="isUpdate"
      :processorInfo="processorSelected"
      :supplierInfo="supplierInfo"
      @onSuccess="getSupplierInfo"
    />
  </div>
</template>

  <script>
import { ButtonHoDo } from '@/components/Button'
import { IconSearch } from '@/components/Icon'
import appUtils from '../../utils/appUtils'
import { DEFAULT_SIZE_OF_PAGE } from '../../utils/constants'
import ModalAddProcessor from './ModalAddProcessor.vue'

export default {
  name: 'OrganizationEcom',
  components: {
    ButtonHoDo,
    IconSearch,
    ModalAddProcessor
  },
  data () {
    return {
      processor: [],
      supplierInfo: {},
      appUtils,
      orgId: 0,
      valueSearch: '',
      totalItems: 0,
      DEFAULT_SIZE_OF_PAGE,
      page: 1,
      dataOrgMember: [],
      processorSelected: {},
      isUpdate: false,
      banks: []
    }
  },

  computed: {
    isProcessor () {
      return this.$user.processor && this.$user.processor.length && this.$user.processor[0].id
    },
    countItems () {
      return this.page * DEFAULT_SIZE_OF_PAGE > this.totalItems
        ? this.totalItems
        : this.page * DEFAULT_SIZE_OF_PAGE
    },
    adminMembers () {
      return this.dataOrgMember
        ? this.dataOrgMember.filter(
          item => item?.role === 1 || item?.role === 2
        )
        : []
    },
    linkPartner () {
      const token = localStorage.getItem('jwt_token')
      const orgId = this.$globalOrg?.id
      if (!token || !orgId) return ''

      // TODO: Remove when have api
      const IS_TEST_PROVIDE = 1

      if (process.env.NODE_ENV === 'development') {
        // `https://partner.dev.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`

        return IS_TEST_PROVIDE === 1
          ? `https://partner.dev.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
          : `https://dev.marketplace.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
      } else {
        // return `https://partner.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
        return IS_TEST_PROVIDE === 1
          ? `https://labs.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
          : `https://marketplace.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
      }
    },
    bankName () {
      return (
        this.banks.find(
          item =>
            Number(item?.bin) === Number(this.supplierInfo?.payment_bank_id)
        )?.name || ''
      )
    }
  },
  watch: {
    $globalOrg () {
      this.callAPI()
    }
  },
  created () {
    this.getBanks()
  },
  mounted () {
    this.callAPI()
  },

  methods: {
    callAPI () {
      this.orgId = this.$globalOrg?.id
      this.getSupplierInfo()
    },

    getAvatar (item) {
      return appUtils.getImageURL(item?.avatar)
    },
    getText (item) {
      return item && item?.name ? item.name.charAt(0) : ''
    },
    async getSupplierInfo () {
      try {
        const userId = this.$user.id
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .getSupplierInfo(userId)

        const responseData = response.data || {}

        this.supplierInfo = { ...responseData }

        this.processor = this.supplierInfo?.processor || []
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: this.$t('lbl_call_api_error'),
          type: 'error'
        })
      }
    },
    handleSearch (e) {
      if (!e.target.value) {
        this.processor = this.supplierInfo?.processor || []
      } else {
        this.processor = this.supplierInfo?.processor?.filter(item =>
          item?.org_info?.name?.includes(e.target.value)
        )
      }
    },
    onShowModalAddProcessor (show) {
      window.$('#ModalAddProcessor').modal(show ? 'show' : 'hide')
    },
    handleOpenLink () {
      window.open(this.linkPartner, '_blank')
    },
    handleEditProcessor (processorInfo) {
      this.processorSelected = processorInfo
      this.isUpdate = true
      this.onShowModalAddProcessor(true)
    },
    async getBanks () {
      try {
        const response = await fetch('https://api.vietqr.io/v2/banks')
        const responseData = await response.json()
        this.banks = responseData?.data || []
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
::v-deep {
  .txt-grey-1000 {
    color: #52575c !important;
  }
  .el-pagination-mdt {
    padding: 0;

    & .number.active {
      background-color: #20419b !important;
    }
  }

  .avatar_admin {
    width: 40px;
    height: 40px;
    object-fit: cover;
    object-position: center;
    border: 1px solid #eeeeee;
    border-radius: 50%;
    cursor: pointer;
  }

  .no_avatar_admin {
    width: 40px;
    height: 40px;
    color: white;
    background: #20419b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    border: 1px solid #eeeeee;
    border-radius: 50%;
    cursor: pointer;
  }

  .button_add {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #9b9999;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
